import Loading from '../misc/Loading';
import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import _ from 'lodash';
import {
  Panel
} from 'react-bootstrap';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import WarrantyModel from '../../../../model/warranty';
import withRouter from '/src/components/misc/withRouter';
import {mapMakeToMakeId} from '/src/components/misc/utils';

class WarrantyDocsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      makeId: null,
      makeSlug: null,
      makeName: null,
      warranties: null
    };

    document.title = `Admin - Garantivilkår - ${this.props.match.params.make}`;
  }

  componentDidMount() {
    if (this.props.match.params.make) {
      this.fetchWarrantyDoc(this.props.match.params.make);
    }
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    if (next.match.params.make) {
      this.setState({
        makeId: null,
        make: null,
        warranties: null
      });
      this.fetchWarrantyDoc(next.match.params.make);
    }
  }

  fetchWarrantyDoc(make) {
    const makeId = mapMakeToMakeId[make];
    WarrantyModel.getByMake(makeId, 2).then((warranties) => {
      this.setState({
        makeId,
        makeSlug: make,
        makeName: _.capitalize(make),
        warranties
      });
    });
  }

  render() {
    if (!this.state.warranties) {
      return (
        <Loading title="Garantivilkår" text="Laster garantivilkår" />
      );
    }

    return (
      <section className="mf-model mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li>Garantivilkår</li>
        </ol>

        <div className="page-header">
          <h1>
            Garantivilkår<br />
            <small>{this.state.makeName}</small>
          </h1>
        </div>

        <div className="row">
          {this.state.warranties.map((warranty) => {
            let statusColor = 'panel-success';
            if (warranty.archived) {
              statusColor = 'panel-danger';
            } else if (warranty.draft) {
              statusColor = 'panel-warning';
            }

            let fileIcon = <i className="fa fa-times text-danger"></i>;
            if (warranty.file) {
              fileIcon = <i className="fa fa-check text-succuss"></i>;
            }

            let textIcon = <i className="fa fa-times text-danger"></i>;
            const actualText = [];
            if (warranty.bodytext && warranty.bodytext.length > 0) {
              warranty.bodytext.forEach((elem) => {
                if (elem.type === 'textBlock' && elem.text !== '') {
                  actualText.push(elem.text);
                }
              });
              if (actualText.length > 0) {
                textIcon = <i className="fa fa-check text-succuss"></i>;
              }
            }

            return (
              <div key={warranty.id} className="col-xs-12 col-sm-4">
                <Panel
                  className={`mg-panel ${statusColor}`}
                >
                  <Panel.Heading className="mg-panel-heading">
                    <Panel.Title componentClass='h4'>
                      {warranty.title} <PublishStatusDot entry={warranty} />
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <div className="row mf-margin-bottom-5">
                      <div className="col-xs-6"><strong>Gjelder</strong></div>
                      <div className="col-xs-6 text-right">{warranty.validFor}</div>
                    </div>
                    <div className="row mf-margin-bottom-5">
                      <div className="col-xs-6"><strong>Fil</strong></div>
                      <div className="col-xs-6 text-right">
                        {fileIcon}
                      </div>
                    </div>
                    <div className="row mf-margin-bottom-5">
                      <div className="col-xs-6"><strong>Tekst</strong></div>
                      <div className="col-xs-6 text-right">
                        {textIcon}
                      </div>
                    </div>
                  </Panel.Body>
                  <Panel.Footer
                    className="text-right"
                  >
                    <Link
                      to={`/warranties/${this.state.makeSlug}/${warranty.id}`}
                      className="btn btn-default"
                    >
                      Rediger <i className="fa fa-pencil"></i>
                    </Link>
                  </Panel.Footer>
                </Panel>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export default withRouter(WarrantyDocsList);
